import { Tooltip } from "antd";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

const fmt = (n) => (typeof n === "number" ? n.toLocaleString() : "–");

const CAVEAT =
  "Savings are estimated from the prompt's instruction text: conversation history and retrieved " +
  "context are excluded, and the tokeniser used for the estimate can differ from the provider's.";

// Conversation-level summary for the details panel. Renders nothing unless the assistant's
// staff-only flag is on and at least one turn exists. The per-turn line under each bubble carries
// the same reading (billed prompt vs. what it would have been without context management); the
// structural facts — instruction text sent vs. total — live here once rather than under every bubble.
export function TurnMetricsCard({ turnMetrics }) {
  const summary = turnMetrics?.summary;
  if (!turnMetrics?.enabled || !summary || !(summary.turnCount > 0)) return null;

  const rows = [
    ["Turns", fmt(summary.turnCount)],
    ["Total Prompt Tokens", fmt(summary.totalPromptTokens)],
  ];
  if (summary.contextManagementActive && summary.promptTokensSaved !== null) {
    rows.push(["Total tokens without context management", `~${fmt(summary.totalPromptTokensWithoutGating)}`]);
    rows.push(["Tokens gated out", `${fmt(summary.promptTokensSaved)} (${summary.savingsPct}%)`]);
    if (typeof summary.instructionTokensBaseline === "number") {
      rows.push([
        "Tokens sent for last turn",
        `${fmt(summary.instructionTokensSentLast)} of ${fmt(summary.instructionTokensBaseline)} tokens`,
      ]);
    }
  } else {
    rows.push(["Context management", "Off"]);
  }
  if (turnMetrics.channel === "voice" && typeof summary.medianDispatchToFirstTokenMs === "number") {
    rows.push(["Median turn latency", `${fmt(summary.medianDispatchToFirstTokenMs)} ms`]);
  }

  return (
    <div className="bg-white border rounded-lg p-4 mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-start">
          <span className="bg-white pr-2 text-sm text-gray-500">
            LLM Metrics
            <Tooltip title={CAVEAT}>
              <InformationCircleIcon className="size-4 inline mx-1 cursor-pointer" />
            </Tooltip>
          </span>
        </div>
      </div>
      {rows.map(([label, value]) => (
        <div key={label} className="mt-4 flex justify-between text-sm gap-x-4">
          <span className="text-gray-500">{label}</span>
          <span className="text-gray-400 text-right">{value}</span>
        </div>
      ))}
    </div>
  );
}
